import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { MapPin } from "lucide-react";
import { updateField } from "../../../../redux/slices/employee-slice";
import { countries } from "../../../../constant/countery";
import { Select } from "antd";

const Address = () => {
  const dispatch = useDispatch();
  const form = useSelector((state) => state.employeeForm);
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    dispatch(updateField({ name, value }));
  };

  const handleSelectChange = (value, name) => {
    dispatch(updateField({ name, value }));
  };

  return (
    <div className="flex items-start justify-between bg-white px-4 mt-6">
      <div className="flex flex-col gap-3 mt-8">
        <MapPin className="h-7 w-7 text-active-color stroke-1" />
        <h4 className="font-semibold text-md">Address</h4>
        <p className="text-gray-400 text-md -mt-2">
          Fill in the employee's address.
        </p>
      </div>
      <div className="bg-form-bg w-lg rounded-md px-4  gap-6 py-8 mr-8 grid grid-cols-12">
        <div className="col-span-6 flex flex-col gap-6">
          {/* first col */}
          <div className="flex flex-col gap-1">
            <label htmlFor="country" className="text-md ">
              Country{" "}
              <span className="text-red-500 relative -top-0.5 ml-0.5">*</span>
            </label>
            <Select
              showSearch
              className="w-full"
              placeholder="Select a country"
              optionFilterProp="value"
              onChange={(value) => handleSelectChange(value, "country")}
              value={form.country}
              filterOption={(input, option) =>
                (option?.value ?? "").toLowerCase().includes(input.toLowerCase())
              }
              options={countries.map(country => ({
                value: country.value,
                label: country.value
              }))}
            />
          </div>

          <div className="flex flex-col gap-1">
            <label htmlFor="zipCode" className="text-md ">
              Zip/Postal Code
            </label>
            <input
              type="text"
              className="border px-2 py-1 rounded-md border-secondary disabled:bg-secondary text-md outline-none bg-white"
              name="zipCode"
              placeholder="Zip/Postal Code"
              onChange={handleChange}
              value={form.zipCode}
            />
          </div>

          <div className="flex flex-col gap-1">
            <label htmlFor="permanentAddress" className="text-md ">
              Permanent Address
            </label>
            <textarea
              placeholder="Address"
              rows={3}
              className="border px-2 py-1 rounded-md border-secondary disabled:bg-secondary text-md outline-none bg-white"
              name="permanent_address"
              onChange={handleChange}
              value={form.permanent_address}
            ></textarea>
          </div>
        </div>
        <div className="col-span-6 flex flex-col gap-6">
          {/* second col */}
          <div className="flex flex-col gap-1">
            <label htmlFor="city" className="text-md ">
              City
              <span className="text-red-500 relative -top-0.5 ml-0.5">*</span>
            </label>
            <input
              type="text"
              className="border px-2 py-1 rounded-md border-secondary disabled:bg-secondary text-md outline-none bg-white"
              name="city"
              placeholder="City"
              onChange={handleChange}
              value={form.city}
            />
          </div>

          <div className="flex flex-col gap-1">
            <label htmlFor="nationality" className="text-md ">
              Nationality
            </label>
            <Select
              showSearch
              className="w-full"
              placeholder="Select nationality"
              optionFilterProp="children"
              onChange={(value) => handleSelectChange(value, "nationality")}
              value={form.nationality}
              filterOption={(input, option) =>
                (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
              }
              options={countries}
            />
          </div>
          <div className="flex flex-col gap-1">
            <label htmlFor="temporaryAddress" className="text-md ">
              Temporary Address
            </label>
            <textarea
              placeholder="Temporary Address"
              rows={3}
              className="border px-2 py-1 rounded-md border-secondary disabled:bg-secondary text-md outline-none bg-white"
              name="temporary_address"
              onChange={handleChange}
              value={form.temporary_address}
            ></textarea>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Address;
